import { render, staticRenderFns } from "./QRTransfer.vue?vue&type=template&id=3cb305ca"
import script from "./QRTransfer.vue?vue&type=script&lang=js"
export * from "./QRTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsSkeletonLoader: require('/app/components/Commons/SkeletonLoader.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
